import ResponsiveField from '@admin/components/mjson_designer/components/responsivefield'
import ImageStyleField from '@admin/components/mjson_designer/components/imagestylefield'
import FlexField from '@admin/components/mjson_designer/components/flexfield'
import LinkField from '@admin/components/mjson_designer/components/linkfield'
import { normalizeConfig } from '../../../utils'
import Button from '@admin/components/button'
import Form from '@admin/components/form'
import * as styles from '../styles'
import PropTypes from 'prop-types'
import settings from '../settings'
import React from 'react'

const Flex = (props) => <ResponsiveField { ...props } component={ FlexField } />

class EditImageBlock extends React.PureComponent {

  static propTypes = {
    device: PropTypes.string,
    entity: PropTypes.object,
    theme: PropTypes.object,
    type: PropTypes.string,
    onChange: PropTypes.func,
    onDone: PropTypes.func
  }

  formRef = React.createRef()

  _handleBrandImage = this._handleBrandImage.bind(this)
  _handleCancel = this._handleCancel.bind(this)
  _handleDone = this._handleDone.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)
  _handleUpdate = this._handleUpdate.bind(this)

  constructor(props) {
    super(props)
    const { entity } = props
    this.state = {
      default: entity,
      config: entity
    }
  }

  render() {
    return <Form { ...this._getForm() } />
  }

  componentDidUpdate(prevProps, prevState) {
    const { config } = this.state
    if(!_.isEqual(config, prevState.config)) {
      this._handleChange()
    }
  }

  _getForm() {
    const { device, entity, theme, type } = this.props
    const { config } = this.state
    return {
      ref: this.formRef,
      onChange: this._handleUpdate,
      onSuccess: this._handleDone,
      showHeader: false,
      buttons: [
        { label: 't(Cancel)', color: 'blue', basic: true, handler: this._handleCancel },
        { label: 't(Done)', color: 'blue', handler: this._handleSubmit }
      ],
      tabs: [
        {
          label: 't(Content)',
          sections: [
            {
              fields: [
                { 
                  type: 'hidden', 
                  name: 'content.image_strategy', 
                  value: config.content.image_strategy || 'upload'
                },
                { 
                  label: 't(Image)', 
                  type: 'segment', 
                  fields: [
                    { 
                      name: 'content.image', 
                      type: 'mediafield', 
                      value: config.content.image, 
                      show: config.content.image_strategy === 'upload',
                      canva_edit: true
                    },
                    { 
                      name: 'content.theme_image', 
                      type: 'dropdown', 
                      options: theme.images.map(image => ({
                        value: image.code,
                        text: image.name
                      })), 
                      entity: 'image', 
                      value: config.content.theme_image, 
                      show: config.content.image_strategy === 'theme' 
                    },
                    { 
                      label: 't(Options)', 
                      type: 'segment', 
                      collapsing: true, 
                      collapsed: true, 
                      fields: [
                        { 
                          label: 't(Quality)', 
                          name: 'content.quality', 
                          type: 'range', 
                          min: 0, 
                          max: 100, 
                          units: '%', 
                          required: true, 
                          defaultValue: 75, 
                          value: config.content.quality 
                        },
                        { 
                          label: 't(DPI)', 
                          name: 'content.dpi', 
                          type: 'optionsfield', 
                          options: [1,2],
                          required: true, 
                          defaultValue: 2, 
                          value: config.content.dpi 
                        }
                      ] 
                    }
                  ],
                  after: (
                    <Button { ...this._getBrandImage() } />
                  )
                },
                { 
                  label: 't(Alt)', 
                  name: 'content.alt', 
                  type: 'textfield', 
                  required: config.content.image, 
                  value: config.content.alt 
                },
                { 
                  label: 't(Link To)', 
                  name: 'content.link', 
                  type: LinkField, 
                  value: config.content.link 
                }
              ]
            }
          ]
        },
        {
          label: 't(Styles)',
          sections: [
            {
              label: 't(Image)',
              collapsing: true,
              collapsed: true,
              fields: [
                { label: 't(Display)', name: 'styles.display', device, canHover: false, type: Flex, omitFeatures: ['height'], theme, defaultValue: {}, value: config.styles.display },
                { label: 't(Image)', name: 'styles.image', device, type: ImageStyleField, omitFeatures: ['display','overlayColor','filters'], theme, defaultValue: {}, value: config.styles.image }
              ]
            },
            styles.BackgroundSection(config, device, theme, type),
            styles.BorderSection(config, device, theme, type),
            styles.SpacingSection(config, device, theme, type),
            styles.VisibilitySection(config, device, theme, type)
          ]
        },
        {
          label: 't(Settings)',
          sections: settings(config, type, entity)
        }
      ]
    }
  }

  _getBrandImage() {
    const { config } = this.state
    return {
      label: config.content.image_strategy === 'theme' ? 't(use custom image)' : 't(use brand image)',
      className: 'link',
      handler: this._handleBrandImage
    }
  }

  _getNormalized() {
    const { entity } = this.props
    const { config } = this.state
    return normalizeConfig({
      ...entity,
      meta: config.meta,
      settings: config.settings,
      styles: config.styles,
      content: config.content
    })
  }

  _handleBrandImage() {
    const { config } = this.state
    this._handleUpdate({
      content: {
        ...config.content,
        image_strategy: config.content.image_strategy === 'upload' ? 'theme' : 'upload'
      }
    })
  }

  _handleCancel() {
    this.props.onDone(this.state.default)
  }

  _handleChange() {
    const config = this._getNormalized()
    this.props.onChange(config)
  }

  _handleDone() {
    const config = this._getNormalized()
    this.props.onDone(config)
  }

  _handleSubmit() {
    this.formRef.current.submit()
  }

  _handleUpdate(config) {
    this.setState({
      config: {
        ...this.state.config,
        ...config
      }
    })
  }

}

export default EditImageBlock
